interface VenueSearchParams {
  page: number;
  service?: string;
  district?: string;
  venue?: string;
  // "Yakınımdakiler" açıkken backend listeyi sayfalamadan önce bu konuma
  // olan mesafeye göre sıralar.
  location?: { lat: number; lng: number } | null;
}

export function buildVenueSearchRoute({
  page,
  service,
  district,
  venue,
  location,
}: VenueSearchParams) {
  let url = `search?index=${page}`;
  if (service) url += `&service=${service}`;
  if (district) url += `&district=${district}`;
  if (venue) url += `&venue=${venue}`;
  if (location) url += `&lat=${location.lat}&lng=${location.lng}`;
  return url;
}
